import { sagas as eventsSagas } from './modules/events'

export default [...eventsSagas]
